import { useState, useCallback } from "react";
import { Nav } from "./Nav";
import { Hero } from "./Hero";
import { CategoryTicker, EditorialMarquee } from "./Marquees";
import { Manifesto } from "./Manifesto";
import { BusinessModel } from "./BusinessModel";
import { Characters } from "./Characters";
import { BrandApplied } from "./BrandApplied";
import { Roadmap } from "./Roadmap";
import { CtaFooter } from "./CtaFooter";
import { ContactPanel } from "./ContactPanel";

export default function DoremigosLandingPage() {
  const [panel, setPanel] = useState({ open: false, subject: "licenciar" });

  const openPanel = useCallback((subject = "licenciar") => {
    setPanel({ open: true, subject });
  }, []);

  const closePanel = useCallback(() => {
    setPanel((p) => ({ ...p, open: false }));
  }, []);

  return (
    <div className="min-h-screen bg-dm-cream text-dm-ink">
      <Nav onContact={() => openPanel("licenciar")} />
      <main>
        <Hero onContact={() => openPanel("licenciar")} />
        <CategoryTicker />
        <Manifesto />
        <BusinessModel />
        <Characters />
        <EditorialMarquee />
        <BrandApplied />
        <Roadmap />
        <CtaFooter
          onContact={() => openPanel("licenciar")}
          onDeck={() => openPanel("deck")}
        />
      </main>
      <ContactPanel open={panel.open} onClose={closePanel} subject={panel.subject} />
    </div>
  );
}
